import {
  CANCEL_FLEXIBLE_OPTIONS,
  CANCEL_FLEXIBLE_OPTIONS_SUCCESS,
  CANCEL_FLEXIBLE_OPTIONS_FAILURE,
  GET_FLEXIBLE_OPTIONS,
  GET_FLEXIBLE_OPTIONS_SUCCESS,
  GET_FLEXIBLE_OPTIONS_FAILURE,
} from '../actions/flexibleOptions';

const INITIAL_STATE = { loading: true, cached: false };

export default function flexibleOptionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_FLEXIBLE_OPTIONS:
      return {
        ...state,
        loading: true,
        cached: true,
      };
    case GET_FLEXIBLE_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        flexiblePaymentOptions: (action.payload && action.payload.flexiblePaymentOptions) || [],
      };
    case GET_FLEXIBLE_OPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        cached: false,
        error: true,
      };
    case CANCEL_FLEXIBLE_OPTIONS:
      return {
        ...state,
        submitting: true,
        submitError: null,
      };
    case CANCEL_FLEXIBLE_OPTIONS_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case CANCEL_FLEXIBLE_OPTIONS_FAILURE:
      return {
        ...state,
        submitting: false,
        submitError: action.payload,
      };
    default:
      return state;
  }
}
